export default __webpack_public_path__ + "static/media/SWT1890.34I-40863_-24174_0.ac31e05e.jpg";